export const recDecisionPoints = 9;
export const recChoices = 27;
export const recBonusContent = 2;
export const recStats = 2;
